import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moneyIcon from '../../../../images/icons/money.svg';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage } from '../../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDetailsOpen: false,
            isCastOpen: false
        };
    }

    toggle = () => {
        this.setState({
            isDetailsOpen: !this.state.isDetailsOpen
        });
        this.props.toggleDetails(this.props.flexpass.id, 'flexpass');
    }

    toggleCast = () => {
        this.setState({
            isCastOpen: !this.state.isCastOpen
        });
    }
    
    componentWillReceiveProps() {
        this.setState({
			isDetailsOpen: this.props.flexpass.isDetailsOpen
		});
    }

    render() {
        return (
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.state.isDetailsOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={this.toggle} aria-label="Close the Flexpass Details modal">&times;</button>

                
                    <div className="showtix-event__details">
                        <div className="showtix-event__details__poster">
                            {this.props.flexpass.poster_graphic_url ?
                                <img src={`${this.props.flexpass.poster_graphic_url}`} alt="" />
                                :
                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} alt="" />
                            }
                            {!this.props.flexpass.poster_graphic_url &&
                                <div className="showtix-event__poster__title">
                                    {this.props.flexpass.name}
                                </div>
                            }
                        </div>
                        <div className="showtix-event__details__content">
                            <span className="showtix-event__details__content__pretitle">{this.props.flexpass.client_name}</span>
                            <h4 className="showtix-event__details__content__title">{this.props.flexpass.name}</h4>
                            <div className="row">
                                <div className="col-12 col-sm-6 showtix-event__details__content__info">
                                    <div className="showtix-event__details__content__info__icon">
                                        <img src={moneyIcon} alt="" />
                                    </div>    
                                    <div className="showtix-event__details__content__info__content">
                                        <p>
                                        {this.props.flexpass.pricing_options.map((price, i) => 
                                            <span key={i}>
                                                {price.desc} - 
                                                {new Intl.NumberFormat('en-US', { 
                                                    style: 'currency', 
                                                    currency: 'USD' 
                                                }).format(price.amount)}
                                                <br />
                                            </span>    
                                        )}
                                        </p>
                                        <div className="showtix-event__details__content__description">
                                            {strings.maxTickets} {this.props.flexpass.max_tickets}
                                        </div>  
                                        <div className="showtix-event__details__content__description mt-2">
                                            {ReactHtmlParser(this.props.flexpass.desc)}
                                        </div>                                       
                                </div>    
                                </div>
                                <div className="col-12 col-sm-6 showtix-event__details__content__info">
                                    <div className="showtix-event__details__content__info__content">
                                        {this.props.flexpass.event_date_ids.length > 0 &&
                                            <p>
                                                {this.props.flexpass.event_date_ids.map(id => {
                                                    <span>id</span>
                                                })}
                                            </p>
                                        }
                                        <p>
                                            {this.props.flexpass.contact_phone}<br />
                                            {this.props.flexpass.website}<br />
                                            <Link to={"mailto" + this.props.flexpass.contact_email}>{this.props.flexpass.contact_email}</Link>
                                        </p>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.flexpass.ad_graphic_url &&
                        <div className="row">
                            <div className="col-12 showtix-event__advertisement">
                                <img src={this.props.flexpass.ad_graphic_url} alt="Advertisement" />
                            </div>
                        </div> 
                    }         
                </ReactModal>            
            </div>
        );
    }
}

FlexpassDetails.propTypes = {
}

export default FlexpassDetails;


// WEBPACK FOOTER //
// ./src/components/EventListing/Flexpass/FlexpassDetails/FlexpassDetails.js